import { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary';

const PdpSharedNotificationMultiplePdpVisitsModalLazy = lazy(() =>
    import(
        /* webpackChunkName: "PdpRespNotificationMultiplePdpVisitsModal" */
        './PdpSharedNotificationMultiplePdpVisitsModal'
    ).then(moduleExport => ({ default: moduleExport.PdpSharedNotificationMultiplePdpVisitsModal }))
);

const PdpSharedNotificationMultiplePdpVisitsModalLoader = props => {
    if (!props.isEnabled) {
        return null;
    }
    return (
        <ErrorBoundary fallback={() => null}>
            <Suspense fallback={null}>
                <PdpSharedNotificationMultiplePdpVisitsModalLazy {...props} />
            </Suspense>
        </ErrorBoundary>
    );
};

PdpSharedNotificationMultiplePdpVisitsModalLoader.propTypes = {
    isEnabled: PropTypes.bool.isRequired,
    itemId: PropTypes.string.isRequired,
};

export { PdpSharedNotificationMultiplePdpVisitsModalLoader };
